import { render, staticRenderFns } from "./ClientGrid.vue?vue&type=template&id=6d525e00&"
import script from "./ClientGrid.vue?vue&type=script&lang=ts&"
export * from "./ClientGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports